




























import Vue from 'vue';

interface IData {
}

interface IMethods {
  clicked: () => void;
}

interface IComputed {
}

interface IProps {
  overview: string;
  image: string;
  averageRating: number;
}

export default Vue.extend<IData, IMethods, IComputed, IProps>({
  name: 'ShowDetails',

  props: {
    image: {
      type: String,
      required: true,
    },

    overview: {
      type: String,
      default: '',
    },

    averageRating: {
      type: Number,
      default: -1,
    },
  },

  data: () => ({
  }),

  async created() {
  },

  computed: {
  },
});
